<div class="meli-card" [ngClass]="{'selected':itemselected}" nz-tooltip
    [nzTooltipTitle]="itemselected ? produto : ''" nzTooltipPlacement="top" nzTooltipColor="#b71c1c">
    <div class="meli-card-header">
        <div class="meli-card-title">{{melidata['id']}}</div>
    </div>
    <nz-divider class="meli-card-divider"></nz-divider>
    <div class="meli-card-content">
        <div class="content-data">
            <div class="dados">
                <div class="title">
                    {{'meli.form.attributes'|translateTA}}
                </div>
                <div class="sumario">
                    <ul class="left">
                        <li *ngFor="let item of melidata['attribute_combinations']">
                            {{item.name}}: {{item.value_name}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="meli-card-actions">
        <button nz-button nzType="primary" (click)="importar($event)">{{'meli.item.selectProduct'|translateTA}}</button>
    </div>
</div>
